/**
 * GCLID Cookie Management for Dashboard
 * Reads Google Ads click IDs from cookies set by the marketing site
 */

/**
 * Get GCLID from cookie
 * @returns {string|null} GCLID value or null if not found
 */
export function getGclid() {
  if (typeof document === 'undefined') return null;

  const cookies = document.cookie.split('; ');
  const gclidCookie = cookies.find((c) => c.startsWith('_gcl_aw='));
  return gclidCookie ? gclidCookie.split('=')[1] : null;
}
